import { Routes } from '@angular/router';

export const LAZY_FEATURE_ROUTES: Routes = [
    {
        path: 'dashboard',
        loadComponent: () => import('../../app/pages/connector-dashboard/connector-dashboard').then(m => m.ConnectorDashboard)
    },
    {
        path: 'connectors',
        loadChildren: () => import('./connectors/connector.routes').then(m => m.CONNECTOR_ROUTES)
    }
];
